import { useQueryGetAllUsers } from "@apis:user/user";
import { SuperDataGrid } from "@components:SuperDataGrid";
import { usePaginationSortDataGrid } from "@hooks:usePaginationSortDataGrid";
import { useTableFilter } from "@hooks:useTableFilter";
import { Box } from "@mui/material";
import { GridActionsCellItem, GridColDef } from "@mui/x-data-grid";
import { UserDeleteModal } from "@pages:settings/Tenent/Users/UserDeleteModal";
import { UserModal } from "@pages:settings/Tenent/Users/UserModal";
import { useUsersData } from "@stores:settings/users";
import { useMemo, useState } from "react";
import { MdDelete, MdModeEdit } from "react-icons/md";

export const UsersTable = () => {
  const [isOpenModalToUpdate, setIsOpenModalToUpdate] = useState(false);
  const [isOpenModalToDelete, setIsOpenModalToDelete] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState<string | null>(null);
  const { searchKeyword, state } = useUsersData();
  const { paginationProps, sortProps } = usePaginationSortDataGrid({
    pageSize: 30,
    defaultSortModel: {
      field: "name",
      sort: "asc",
    },
  });

  const { data, isLoading } = useQueryGetAllUsers();

  const cleanedData = useTableFilter({
    filters: [
      {
        field: "enabled",
        operator: "equals",
        value: state === "active",
      },
      {
        field: "email",
        operator: "contains",
        value: searchKeyword,
      },
    ],
    data,
  });

  const columns: GridColDef[] = useMemo(
    () => [
      {
        field: "name",
        headerName: "Name",
        flex: 1,
      },
      {
        field: "email",
        headerName: "Email",
        flex: 1,
      },
      {
        field: "role",
        headerName: "Role",
        flex: 1,
      },
      {
        field: "actions",
        type: "actions",
        headerName: "",
        align: "right",
        flex: 1,
        getActions: (params: any) => {
          const editButton = (
            <GridActionsCellItem
              icon={<MdModeEdit size={20} />}
              label="Edit"
              className="textPrimary"
              color="primary"
              onClick={() => {
                setIsOpenModalToUpdate(true);
                setSelectedUserId(params.row.id);
              }}
            />
          );

          const deleteButton = (
            <GridActionsCellItem
              icon={<MdDelete size={20} />}
              label="Delete"
              color="error"
              onClick={async () => {
                setIsOpenModalToDelete(true);
                setSelectedUserId(params.row.id);
              }}
            />
          );

          const actions = [editButton];
          if (params?.row?.enabled) {
            actions.push(deleteButton);
          }

          return actions;
        },
      },
    ],
    [],
  );

  return (
    <Box
      sx={{
        height: "100%",
      }}
    >
      <SuperDataGrid
        columns={columns}
        rows={cleanedData}
        loading={isLoading}
        {...paginationProps}
        {...sortProps}
        for="users"
        noRowsOverlayText="No users found"
        sx={{
          "& .MuiDataGrid-row--borderBottom": {
            backgroundColor: "white !important",
          },
        }}
      />
      {isOpenModalToUpdate && (
        <UserModal
          isOpen={isOpenModalToUpdate}
          onClose={() => setIsOpenModalToUpdate(false)}
          userId={selectedUserId!}
        />
      )}
      {isOpenModalToDelete && (
        <UserDeleteModal
          isOpen={isOpenModalToDelete}
          onClose={() => setIsOpenModalToDelete(false)}
          userId={selectedUserId!}
        />
      )}
    </Box>
  );
};
